import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import { AuthProvider, useAuth } from './contexts/AuthContext';
import Layout from './components/Layout/Layout';
import Login from './components/Login';
import LandingPage from './pages/LandingPage';
import SettingsPage from './pages/SettingsPage';
import InputsPage from './pages/InputsPage';
import TablePackingPage from './pages/TablePackingPage';
import OutputsPage from './pages/OutputsPage';
import ConstraintsAnalysisPage from './pages/ConstraintsAnalysisPage';

function AppContent() {
  const { isAuthenticated } = useAuth();

  if (!isAuthenticated) {
    return <Login />;
  }

  return (
    <Router>
      <div className="App">
        <Toaster position="top-right" />
        <Layout>
          <Routes>
            <Route path="/" element={<LandingPage />} />
            <Route path="/settings" element={<SettingsPage />} />
            <Route path="/inputs" element={<InputsPage />} />
            <Route path="/table-packing" element={<TablePackingPage />} />
            <Route path="/constraints-analysis" element={<ConstraintsAnalysisPage />} />
            <Route path="/outputs" element={<OutputsPage />} />
          </Routes>
        </Layout>
      </div>
    </Router>
  );
}

function App() {
  return (
    <AuthProvider>
      <AppContent />
    </AuthProvider>
  );
}

export default App;